"use strict";
exports.__esModule = true;
exports.SCREEN_OPTIONS = exports.DEFAULT_SCREEN = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var utilities_1 = require("../../../utilities/utilities");
var MessageBlock_1 = tslib_1.__importStar(require("../../components/MessageBlock"));
exports.DEFAULT_SCREEN = 'all';
exports.SCREEN_OPTIONS = [
    {
        value: 'all',
        label: 'Vždy'
    },
    {
        value: 'desktop',
        label: 'Iba desktop'
    },
    {
        value: 'mobile',
        label: 'Iba mobil'
    },
];
var Advert = function (_a) {
    var _b;
    var renderEmpty = _a.renderEmpty, _c = _a.data, data = _c === void 0 ? {} : _c;
    var screen = data.screen || exports.DEFAULT_SCREEN;
    if (renderEmpty) {
        var screenLabel = ((_b = exports.SCREEN_OPTIONS.find(function (o) { return o.value === screen; })) === null || _b === void 0 ? void 0 : _b.label) || '';
        return (react_1["default"].createElement(MessageBlock_1["default"], { color: "primary" },
            utilities_1.__('Reklama'),
            react_1["default"].createElement(MessageBlock_1.Description, null,
                utilities_1.__('Zobrazenie'), ": ",
                screenLabel)));
    }
    return null;
};
exports["default"] = Advert;
